// stores/useRolePlayStore.ts
import { create } from 'zustand'
import { Persona } from '../types/domain/persona'

//this state only beloings in justand.
interface PersonaState {
  jobCategories: any[]
  setJobCategories: (categories: any[]) => void

  personas: Persona[]
  setPersonas: (list: Persona[]) => void

  removePersona: (id: number) => void
  step: number

  jobCategoryId: number
  setJobCategoryId: (id: number) => void

  companyTypeId: number
  setCompanyTypeId: (id: number) => void

  experienceDurationId: number
  setExperienceDurationId: (id: number) => void
  // toggleSelection: (id: number) => void
  showCustomWorkDuration: boolean
  toggleShowCustomWorkDuration: () => void

  customExperienceDuration: string
  setCustomExperienceDuration: (string) => void
  // customPurpose: string
  background: string

  //관계
  relationshipId: number | null
  setRelationshipId: (number) => void

  //친밀도
  intimacyId: number | null
  setIntimacyId: (number) => void

  //성향
  toneId: number | null
  setToneId: (number) => void

  ageId: number | null
  setAgeId: (number) => void

  pronunciationId: number | null
  setPronunciationId: (number) => void

  genderId: number | null
  setGenderId: (number) => void

  additionalInfo: string
  setAdditionalInfo: (string) => void

  //상대 이름
  name: string
  setName: (string) => void

  setStep: (step: number) => void
  nextStep: () => void
  prevStep: () => void
  // setCustomPurpose: (text: string) => void
  // toggleShowCustomPurpose: () => void
  setBackground: (text: string) => void
}

export const usePersonaStore = create<PersonaState>((set) => ({
  step: 0,

  //this data is from the server.
  jobCategories: [],
  setJobCategories: (list) => set({ jobCategories: list }),

  personas: [
    // {
    //   companyTypeId: 1,
    //   toneId: 1,
    //   relationshipId: 2,
    //   intimacyId: 1,
    //   ageId: 2,
    //   pronunciationId: 1,
    //   genderId: 1,
    //   experienceDurationId: 1,
    //   additionalInfo: 'hahahahahah',
    //   name: '성파',
    // },
    // {
    //   companyTypeId: 3,
    //   toneId: 2,
    //   relationshipId: 3,
    //   intimacyId: 4,
    //   ageId: 1,
    //   pronunciationId: 2,
    //   genderId: 2,
    //   experienceDurationId: 2,
    //   additionalInfo: 'hahahah23123123ahah',
    //   name: '양혜인',
    // },
  ],

  setPersonas: (list) => set({ personas: list }),

  removePersona: (id) =>
    set((state) => ({
      personas: state.personas.filter((p) => p.id !== id),
    })),

  jobCategoryId: null,
  setJobCategoryId: (id) => set({ jobCategoryId: id }),

  companyTypeId: null,
  setCompanyTypeId: (id) => set({ companyTypeId: id }),

  experienceDurationId: null,
  setExperienceDurationId: (id) => set({ experienceDurationId: id }),

  showCustomWorkDuration: false,
  toggleShowCustomWorkDuration: () =>
    set((state) => ({
      showCustomWorkDuration: !state.showCustomWorkDuration,
    })),

  customExperienceDuration: '',
  setCustomExperienceDuration: (text) => set({ customExperienceDuration: text }),

  background: '',

  relationshipId: null,
  setRelationshipId: (id) => set({ relationshipId: id }),

  intimacyId: null,
  setIntimacyId: (id) => set({ intimacyId: id }),

  toneId: null,
  setToneId: (id) => set({ toneId: id }),

  ageId: null,
  setAgeId: (id) => set({ ageId: id }),

  genderId: null,
  setGenderId: (id) => set({ genderId: id }),

  pronunciationId: null,
  setPronunciationId: (id) => set({ pronunciationId: id }),

  additionalInfo: '',
  setAdditionalInfo: (text) => set({ additionalInfo: text }),

  name: null,
  setName: (text) => set({ name: text }),

  setStep: (step) => set({ step }),
  nextStep: () => set((s) => ({ step: s.step + 1 })),
  prevStep: () => set((s) => ({ step: Math.max(0, s.step - 1) })),
  // toggleShowCustomPurpose: () => set((s) => ({ showCustomPurpose: !s.showCustomPurpose })),
  // setCustomPurpose: (text) => set({ customPurpose: text }),
  setBackground: (text) => set({ background: text }),
}))
